const removeDateFromType = (date) => date.replace(/^\d{2}\.\d{2}\.\d{4}_/, '');
attachEvent('.hero-module__item', 'click', (ev) => {
  const heroButton = ev.target.closest('.hero-module__item');
  if (heroButton && heroButton.dataset.button === '3') {
    sendDataToDataLayerSelectItem('gifts');
  }
});

attachEvent('.payment-summary__popup-trigger', 'click', () => {
  setSummary();
});

attachEvent('.payment-summary__header-inner a, .payment-summary__button-payment a', 'click', () => {
  setSummary('begin_checkout');
});

const sendDataLayerPush = (object) => {
  console.log(object);
  if (typeof dataLayer !== 'undefined' && dataLayer !== null) {
    dataLayer.push(object);
  }
}

const sendDataToDataLayerSelectItem = (el) => {
  sendDataLayerPush({
    event: 'select_item',
    ecommerce: {
      item_list_id: 'related_products',
      item_list_name: 'Related products',
      items: [
        {
          item_name: el,
        }
      ]
    }
  });
};

const getTypeItem = (item, displayGift = true) =>  item.querySelector('input[name="adults"]') ? '_adults' : item.querySelector('input[name="children"]') ? '_children' : (displayGift ? '_gift' : '')

// eslint-disable-next-line no-unused-vars
const setAddRemove = (element, operation) => {
  const article = element.closest('.counter-block');
  const price = article.querySelector('.counter-price').value;
  const type = getTypeItem(article, false);
  const data = article.closest('.order-summary__body-inner').dataset.key;
  sendDataLayerPush({
    event: operation === 'remove' ? 'remove_from_cart' : 'add_to_cart',
    ecommerce: {
      currency: 'EUR',
      value: Number(price),
      items: [
        {
          item_id: `${removeDateFromType(data)}${type}`,
          item_name: `${removeDateFromType(data)}${type}`,
          price: Number(price),
          quantity: 1,
          item_category: data.includes('gift') ? 'Boni' : 'Vstopnice'
        }
      ]
    }
  })
};

// eslint-disable-next-line no-unused-vars
const setAddRemoveNew = (element, data) => {
  const priceAdult = Number(element.dataset.priceAdult || 0);
  const priceChildren = Number(element.dataset.priceChild || 0);
  const type = element.dataset.date === '' ? 'gift' : 'ticket';
  const value = type === 'ticket'
      ? (priceAdult * (data.adults || 0)) + (priceChildren * (data.children || 0))
      : Number(element.dataset.price) * data.quantity;

  const items = type === 'ticket'
      ? [
        {
          item_id: `${data.type}_adults`,
          item_name: `${data.type}_adults`,
          price: priceAdult,
          quantity: Number(data.adults || 0),
          item_category: 'Vstopnice'
        },
        {
          item_id: `${data.type}_children`,
          item_name: `${data.type}_children`,
          price: priceChildren,
          quantity: Number(data.children || 0),
          item_category: 'Vstopnice'
        }
      ]
      : [
        {
          item_id: `gift_${data.type}`,
          item_name: `gift_${data.type}`,
          price: Number(element.dataset.price || 0),
          quantity: Number(data.quantity || 0),
          item_category: 'Boni'
        }
      ];
  sendDataLayerPush({
    event: 'add_to_cart',
    ecommerce: {
      currency: 'EUR',
      value,
      items
    }
  });
};

const processItems = (cartItems, event) => {
  const dataObj = [];
  let priceAll = 0;
  cartItems.forEach((item) => {
    const innerCounterPrice = item.querySelectorAll('.counter__inner input[name="counter-price"]');
    innerCounterPrice.forEach((inner) => {
      const type = getTypeItem(inner.closest('.counter__inner'), false);
      const name = inner.closest('.order-summary__body-inner').dataset.key;
      const price = Number(inner.value);
      const numberOf = Number(inner.closest('.counter__inner').querySelector('.counter__input').value);
      priceAll += numberOf * price;
      if (numberOf) {
        dataObj.push({
          item_id: `${removeDateFromType(name)}${type}`,
          item_name: `${removeDateFromType(name)}${type}`,
          price,
          quantity: numberOf,
          item_category: name.includes('gift') ? 'Boni' : 'Vstopnice'
        });
      }
    });
  });
  sendDataLayerPush({
    event,
    ecommerce: {
      currency: 'EUR',
      value: priceAll,
      items: dataObj
    }
  })
};

// eslint-disable-next-line no-unused-vars
const removeAllEvent = (item) => {
  const cartItems = [item];
  processItems(cartItems, 'remove_from_cart');
};

const setSummary = (event = 'view_cart') => {
  if (event === 'view_cart' && document.querySelector('.payment-summary.is-open-modal')) {
    return;
  }
  const cartItems = document.querySelectorAll('.order-summary .order-summary__body-inner');
  processItems(cartItems, event);
};
